import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "../../../../styles/scope3/Dashboard/transportation.module.css";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import { monthSort } from "../../../../utils/constant";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";

const EmissionLineChart = ({
  title,
  emission,
  emissionFilter,
  setEmissionFilter,
  createLinechartDataset,
  display,
  lineTitle,
}) => {

  const fixedValue = (value) => {
    if (value == null || isNaN(value)) return 0;
    const num = parseFloat(value);
    return num % 1 === 0 ? num : num.toFixed(3);
  };

  console.log(emission);
  return (
    <div>
      <p className={styles.card_heading}>{title}</p>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "1.2rem",
        }}
      >
       {emission?.map((el, idx) => {
  console.log(`Dataset for ${el?.emission}:`, el?.dataset);
  console.log(`Dataset2 for ${el?.emission}:`, el?.dataset2);

  return (
          <div key={idx} className={styles.comparative_container}>
            <div className={styles.cards}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "2rem",
                }}
              >
                <div>
                  <p className={styles.emission_heading}>
                    {el?.emission} Transport Emission (tCO2e):
                    <span className={styles.emission_heading_span}>
                      {formatNumberCommaSeparated(
                        fixedValue(
                          emissionFilter?.[el?.emission] === "Annual"
                            ? el?.annualSum || el?.annualValue
                            : el?.yearSum || el?.yearValue
                        )
                      )}
                    </span>
                    {emissionFilter?.[el?.emission] === "Annual" && (
                      <span
                        className={styles.emission_heading_percent}
                        style={{
                          color:
                            el?.percentageDifference >= 0 ? "#00C851" : "red",
                          marginLeft: "0.2rem",
                        }}
                      >
                        {" "}
                        ({el?.percentageDifference >= 0 && "+"}
                        {formatNumberCommaSeparated(
                          truncateNumber(
                            fixedValue(el?.percentageDifference),
                            2
                          )
                        )}
                        % YOY{" "}
                        {el?.percentageDifference >= 0 ? (
                          <TrendingUpIcon sx={{ fontSize: "18px" }} />
                        ) : (
                          <TrendingDownIcon sx={{ fontSize: "18px" }} />
                        )}
                        )
                      </span>
                    )}
                  </p>
                </div>
                <div>
                  <Typography
                    style={{ fontSize: "12px", marginBottom: "-0.5" }}
                  >
                    Filter By :
                  </Typography>
                  <select
                    name={el?.emission}
                    id="month"
                    value={emissionFilter?.[el?.emission]}
                    onChange={(e) =>
                      setEmissionFilter({
                        ...emissionFilter,
                        [el?.emission]: e.target.value,
                      })
                    }
                    className={styles.heading_select_month}
                    style={{ width: "8rem" }}
                  >
                    {["Annual", "Year On Year"].map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>
              </Box>
              <LineChart
                display={display}
                dataset={
                  (emissionFilter?.[el?.emission] === "Annual"
                    ? el?.twelveMonthData?.map((e) => e?.totalEmission)
                    : el?.tenYearData?.map((e) => e?.totalEmission)
                  )?.filter(Boolean)?.length > 0
                  ? createLinechartDataset ? createLinechartDataset(
                        [el?.emission],
                        ["red"],
                        emissionFilter?.[el?.emission] === "Annual"
                          ? el?.twelveMonthData?.map((e) => e?.totalEmission)
                          : el?.tenYearData?.map((e) => e?.totalEmission)
                      ):[]
                    : emissionFilter?.[el?.emission] === "Annual"
                    ? el?.dataset?.length > 0
                      ? el?.dataset
                      : []
                    : el?.dataset2?.length > 0
                    ? el?.dataset2
                    : []
                }
                labels={
                  emissionFilter?.[el?.emission] === "Annual"
                    ? lineTitle === "stream"
                      ? el?.monthLabel
                      : el?.twelveMonthData?.map(
                          (el) =>
                            monthSort[el?.month - 1] +
                            "'" +
                            el?.year.toString().slice(-2)
                        )
                    : createLinechartDataset
                    ? el?.tenYearData?.map((e) => e?.year)
                    : el?.yearSort
                }
                // yAxisTitle={"Emissions (tCO2e)"}
                customWidth="100%" // Optional custom width
              />
            </div>
          </div>
       )})}
      </Box>
    </div>
  );
};

export default EmissionLineChart;
